"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const forceRedirect = (ssoHost, redirectTo, consumer) => {
    try {
        const cleanSsoHost = ssoHost.split("?")[0].replace(/\/$/, "");
        const url = new URL(`${cleanSsoHost}/login`);
        if (consumer) {
            url.searchParams.append("consumer", consumer);
        }
        url.searchParams.append("redirectTo", redirectTo);
        window.location.href = url.toString();
    }
    catch (e) {
        console.error("Error in forceRedirect:", e);
    }
};
const authMachineUtils = {
    forceRedirect,
};
exports.default = authMachineUtils;
